import WidgetModule from "@eisinc/Overrides/Widgets/Basic/Row";

export * from "@eisinc/Overrides/Widgets/Basic/Row";

export default WidgetModule;
